import {
  NotificacaoLogDetalheDiaDTO,
  NotificacaoLogDTO,
  NotificacaoLogFiltrosCriteria,
  NotificacaoLogFiltrosOptions,
  NotificacaoLogResumoDTO,
  NotificacaoLogResumoPorCanalDiaDTO,
  PeriodoResumoNotificacao,
} from "@/types/notificacao-log.type";
import { PageResponse } from "@/types/http.type";
import { buildQueryParams } from "@/utils/build-query-params";
import { httpClient } from "./httpClient";

/**
 * Métricas admin de notificações: histórico paginado dos envios (quantos saíram,
 * para quem, com qual conteúdo) + opções de filtro. Espelha o `ArquivoAuditoriaService`.
 */
class NotificacaoLogService {
  private readonly basePath = "api/v1/admin/notificacoes/logs";

  public async listPaginado(
    filter?: NotificacaoLogFiltrosCriteria,
  ): Promise<PageResponse<NotificacaoLogDTO>> {
    let url = `${this.basePath}/listagem`;
    if (filter) {
      const query = buildQueryParams(filter);
      if (query) url += "?" + query;
    }
    return httpClient.get<PageResponse<NotificacaoLogDTO>>(url);
  }

  public async getFiltros(): Promise<NotificacaoLogFiltrosOptions> {
    return httpClient.get<NotificacaoLogFiltrosOptions>(`${this.basePath}/filtros`);
  }

  public async getResumo(dias: PeriodoResumoNotificacao): Promise<NotificacaoLogResumoDTO> {
    return httpClient.get<NotificacaoLogResumoDTO>(`${this.basePath}/resumo?dias=${dias}`);
  }

  public async getResumoPorCanal(
    dias: PeriodoResumoNotificacao,
  ): Promise<NotificacaoLogResumoPorCanalDiaDTO[]> {
    return httpClient.get<NotificacaoLogResumoPorCanalDiaDTO[]>(
      `${this.basePath}/resumo-canal?dias=${dias}`,
    );
  }

  public async getDetalheDia(dia: string): Promise<NotificacaoLogDetalheDiaDTO> {
    return httpClient.get<NotificacaoLogDetalheDiaDTO>(
      `${this.basePath}/resumo-canal/detalhe?dia=${dia}`,
    );
  }
}

export const notificacaoLogService = new NotificacaoLogService();
